// extracted by mini-css-extract-plugin
module.exports = {"root":"EditAdminPage_root__Xm0qX","tabpanel":"EditAdminPage_tabpanel__UON5Z","tabItemTitle":"EditAdminPage_tabItemTitle__2HiE3","tabItem":"EditAdminPage_tabItem__3f-a5"};